const body = document.querySelector('body');
export default body;
